import { Link } from "react-router-dom";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import { PageMeta } from "@/components/common/PageMeta";
import { ContactHero } from "@/components/contact/ContactHero";
import { ContactForm } from "@/components/contact/ContactForm";
import { ContactDetails } from "@/components/contact/ContactDetails";
import { FAQSection } from "@/components/contact/FAQSection";

export function ContactPage() {
  return (
    <>
      <PageMeta
        title="Get in Touch | COSX"
        description="Contact COSX to learn about our AI agents for regulated industries, explore partnership opportunities, or ask about our platform and security."
        path="/contact"
      />

      <ContactHero />

      <ScrollSection id="contact" title="Send us a message" compact>
        <div className="grid grid-cols-1 md:grid-cols-[1fr_280px] gap-12 md:gap-16">
          <ContactForm />
          <ContactDetails />
        </div>
      </ScrollSection>

      <ScrollSection id="faq" title="Frequently asked questions" compact>
        <FAQSection />
      </ScrollSection>

      <ScrollSection
        id="explore"
        title="While you're here"
        subtitle="Learn more about what we're building and the team behind it."
        compact
      >
        <div className="flex flex-wrap gap-4">
          <Link
            to="/platform"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
          >
            View the platform →
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
          >
            See our products →
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
          >
            About the team →
          </Link>
        </div>
      </ScrollSection>
    </>
  );
}
